import Component from '../core/Component'

export default class OffersSlider extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            fillers: []
        }
    }

    prepare() {
        this.ref.fillers.forEach(filler => {
            filler.style.background = `radial-gradient(closest-side, #f8f5ed 95%, transparent 95% 100%), conic-gradient(#af9257 ${filler.dataset.value}%, rgba(0,0,0,0.12) 0)`
        })
    }
}
